/**
 * Any mime types must be one of the standard mime types defined in the IANA registry.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
 * @see https://www.iana.org/assignments/media-types/media-types.xhtml
 */
export const vectorImages = [
    'application/pdf',
    'application/illustrator',
    'application/eps',
    'application/postscript',
    'image/svg+xml',
    'image/x-eps',
    'image/x-emf',
    'image/vnd.dxf',
    'application/vnd.ms-3mfdocument',
    'application/x-shockwave-flash',
    'application/vnd.corel-draw',
    'application/x-cdr',
    'image/x-fig',
    'application/x-tgif',
    'application/x-skencil',
];
export const rasterImages = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/tiff',
    'image/bmp',
    'image/x-windows-bmp',
    'image/webp',
    'image/vnd.adobe.photoshop',
    'image/vnd.wap.wbmp',
    'image/x-icon',
    'image/vnd.microsoft.icon',
    'image/jp2',
    'image/jpx',
    'image/vnd.ms-modi',
];
export const commonMimeTypes = {
    archives: [
        'application/zip', // ZIP
        'application/x-7z-compressed', // 7z
        'application/x-rar-compressed', // RAR
        'application/vnd.rar', // RAR
        'application/x-tar', // TAR
        'application/x-gzip', // Gzip
        'application/gzip-compressed-tar', // Gzip
        'application/x-freearc', // FreeArc
    ],
    documents: [
        'application/atom+xml', // Atom
        'application/epub+zip', // ePub
        'application/gzip', // Gzip
        'application/java-archive', // Java Archive
        'application/json', // JSON
        'application/ld+json', // JSON-LD
        'application/msword', // Word
        'application/ogg', // Ogg
        'application/pdf', // PDF
        'application/rtf', // RTF
        'application/vnd.amazon.ebook', // Amazon Kindle eBook
        'application/vnd.apple.installer+xml', // Apple Installer Package
        'application/vnd.mozilla.xul+xml', // XUL
        'application/vnd.ms-excel', // Excel
        'application/vnd.ms-fontobject', // EOT
        'application/vnd.ms-powerpoint', // PowerPoint
        'application/vnd.oasis.opendocument.presentation', // OpenDocument Presentation
        'application/vnd.oasis.opendocument.spreadsheet', // OpenDocument Spreadsheet
        'application/vnd.oasis.opendocument.text', // OpenDocument Text
        'application/vnd.openxmlformats-officedocument.presentationml.presentation', // PowerPoint (OpenXML)
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel (OpenXML)
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Word (OpenXML)
        'application/vnd.visio', // Visio
        'application/x-abiword', // AbiWord
        'application/x-cdf', // CDF
        'application/x-csh', // C-Shell Script
        'application/x-httpd-php', // PHP
        'application/x-sh', // Shell Script
        'application/x-midi', // MIDI
        'application/xhtml+xml', // XHTML
        'application/xml', // XML
        'text/csv', // CSV
        'text/html', // HTML
        'text/javascript', // JavaScript
        'text/plain', // Plain Text
        'text/xml', // XML
        'text/rtf', // RTF
    ],
    audio: [
        'audio/3gpp', // 3GPP
        'audio/3gpp2', // 3GPP2
        'audio/aac', // AAC
        'audio/midi', // MIDI
        'audio/mpeg', // MP3
        'audio/ogg', // Ogg
        'audio/opus', // Opus
        'audio/wav', // WAV
        'audio/webm', // WebM
        'audio/x-midi', // MIDI
    ],
    fonts: ['font/otf', 'font/ttf', 'font/woff', 'font/woff2'],
    images: ['image/avif', 'image/heif', 'image/heic', ...vectorImages, ...rasterImages],
    vectorImages,
    rasterImages,
    videos: [
        'video/3gpp', // 3GPP
        'video/3gpp2', // 3GPP2
        'video/mp2t', // MPEG2 Transport Stream
        'video/mp4', // MP4
        'video/mpeg', // MPEG
        'video/ogg', // Ogg
        'video/webm', // WebM
        'video/vnd.avi', // AVI
        'video/avi', // AVI
        'video/msvideo', // AVI
        'video/x-msvideo', // AVI
    ],
    workingFiles: [
        'application/vnd.adobe.photoshop', // Photoshop
        'application/x-sketch', // Sketch
        'application/vnd.figma.document', // Figma
        'application/vnd.ms-powerpoint', // PowerPoint
        'application/vnd.openxmlformats-officedocument.presentationml.presentation', // PowerPoint (OpenXML)
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Word (OpenXML)
        'application/vnd.ms-excel', // Excel
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel (OpenXML)
        'application/pdf', // PDF
        'application/illustrator', // Adobe Illustrator
        'application/zip', // ZIP files
        'application/vnd.autodesk.autocad.dwg', // AutoCAD
        'application/eps', // EPS
        'application/postscript', // PostScript
        'application/vnd.ms-3mfdocument', // 3D Manufacturing Format
        'application/x-shockwave-flash', // Flash
        'application/vnd.corel-draw', // CorelDRAW
        'application/x-cdr', // CorelDRAW
        'application/x-skencil', // Skencil
        // Additional MIME types
        'application/vnd.adobe.premiere', // Adobe Premiere Pro
        'application/vnd.adobe.indesign', // Adobe InDesign
        'video/quicktime', // iMovie, Final Cut Pro
        'application/x-davinci-resolve', // DaVinci Resolve
        // 3D Modeling
        'application/octet-stream', // FBX (common use)
        'application/x-tgif', // OBJ
        'model/vnd.dwf', // DWF
        'application/vnd.geogebra.file', // GDL (general approximation)
        'application/vnd.geogebra.tool', // GTS (general approximation)
        'model/iges', // IGES (IGFS)
        'model/gltf-binary', // glTF
    ],
};
export const allCommonMimeTypes = Object.values(commonMimeTypes).flat();
//# sourceMappingURL=mime-types.js.map